export default __webpack_public_path__ + "static/media/mobileBg@2x.f2c0b53e.png";